export default function ({ email }) {
  return this.sendEvent('auth.login', { email })
}
